import type { Mode, Op } from "../content/modes";
import { OPS } from "../content/modes";

export function enabledOps(ops: Record<Op, boolean>): Op[] {
  const on = OPS.filter((k) => ops[k]);
  return on.length ? on : ["add"];
}

/** The operations a mode draws from. Mix uses every enabled op. */
export function opsForMode(mode: Mode, ops: Record<Op, boolean>): Op[] {
  return mode === "mix" ? enabledOps(ops) : [mode];
}

/** Modes available: every enabled operation, plus Mix when there's more than one. */
export function availableModes(ops: Record<Op, boolean>): Mode[] {
  const on = enabledOps(ops);
  return on.length > 1 ? [...on, "mix"] : on;
}
